<app-tabs class="tabbed-dialog-tabs">
  <app-tab class="tab-with-fixed-footer" tabTitle="Ändra" (activeChange)="bulkChangeTabActive = $event">
    <app-bulk-change
      class="tabbed-dialog-pane"
      [type]="BulkTypeChange"
      actionSelectPlaceholder="Välj vad du vill ändra"
      [active]="tabActive && bulkChangeTabActive">
      <p actionTitle>Vad vill du ändra?</p>
    </app-bulk-change>
  </app-tab>
  <app-tab class="tab-with-fixed-footer" tabTitle="Lägg till" (activeChange)="bulkAddTabActive = $event">
    <app-bulk-change
      class="tabbed-dialog-pane"
      [type]="BulkTypeAdd"
      actionSelectPlaceholder="Välj vad du vill lägga till"
      [active]="tabActive && bulkAddTabActive">
      <p actionTitle>Vad vill du lägga till?</p>
    </app-bulk-change>
  </app-tab>
  <app-tab class="tab-with-fixed-footer" tabTitle="Ta bort" (activeChange)="bulkRemoveTabActive = $event">
    <app-bulk-change
      class="tabbed-dialog-pane"
      [type]="BulkTypeRemove"
      actionSelectPlaceholder="Välj vad du vill ta bort"
      [active]="tabActive && bulkRemoveTabActive">
      <p actionTitle>Vad du vill ta bort?</p>
    </app-bulk-change>
  </app-tab>
</app-tabs>
